import Vue from 'vue'
import AuthService from './auth.service'
/** 
 * 
 */
export default {
    /**
     * 合并报告并下载
     *
     * @param {*} [params={orderID:0}]
     * @param {*} [config={}]
     * @returns
     */
    async downloadReportByOrder(params = {}, config = {}) {
        AuthService.getToken();
        config.params = params;
        let result = await Vue.http.get('/UserOrderInfoTestItemTypeOrder/DownloadReportByOrder', config);
        return result;
    }
}


// WEBPACK FOOTER //
// ./src/_services/userOrderInfoTestTypeOrder.service.js